import { IDailyRecord } from "../../../lib/types";
import React from "react";
import { fullDate } from "../../../lib/utils";
import DailyTodo from "./DailyTodo";

interface DailyTodosProps {
    todos: IDailyRecord[];
    setTodos: React.Dispatch<React.SetStateAction<IDailyRecord[]>>;
    date: Date;
}

export default function DailyTodos({ todos, date, setTodos }: DailyTodosProps) {
    const today = new Date();

    return (
        <>
            {todos.filter((x) => x.date === fullDate(date || today)).length === 0 && <div className="mt-4 text-sm italic text-slate-400">Still nothing to do this day...</div>}
            <div className="mt-6 flex flex-col gap-4">
                {todos
                    .filter((x) => x.date === fullDate(date || today))
                    .map((todo, index) => {
                        return <DailyTodo key={todo.id} todos={todos} todo={todo} setTodos={setTodos} />;
                    })}
            </div>
        </>
    );
}
